import { Dispatch } from "react";
import { SidebarHeader, SidebarInput } from "@/components/ui/sidebar";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import JobAdsDropdown from "@/components/job-ads-dropdown";
import { JobAd } from "@/types/jobAdsTypes";
import { ReviewFilter, SenderFilter } from "@/types/chat";
import { isFeatureEnabled } from "@/lib/featureFlags";

interface ChatSidebarHeaderProps {
  adsSnapshot: any;
  navigateToAd: any;
  selectedAd: JobAd | null;
  searchTerm: string;
  setSearchTerm: Dispatch<React.SetStateAction<string>>;
  senderFilter: SenderFilter;
  setSenderFilter: Dispatch<React.SetStateAction<SenderFilter>>;
  reviewFilter: ReviewFilter;
  setReviewFilter: (filter: ReviewFilter) => void;
}

export default function ChatSidebarHeader({
  adsSnapshot,
  navigateToAd,
  selectedAd,
  searchTerm,
  setSearchTerm,
  senderFilter,
  setSenderFilter,
  reviewFilter,
  setReviewFilter,
}: ChatSidebarHeaderProps) {
  return (
    <SidebarHeader className="gap-3.5 border-b p-4">
      <div className="flex w-full items-center justify-between">
        {adsSnapshot && (
          <div className="flex flex-col">
            <Label htmlFor="job-ads-dropdown" className="mb-1">
              Välj annons
            </Label>
            <JobAdsDropdown
              /* id="job-ads-dropdown" */
              jobAdsSnapshot={adsSnapshot}
              onAdClick={navigateToAd}
              selectedAd={selectedAd}
            />
          </div>
        )}
        {/*  <Label className="flex items-center gap-2 text-sm">
                <span>Olästa</span>
                <Switch className="shadow-none" />
              </Label> */}
      </div>
      <div className="flex gap-2">
        <div className="w-1/2">
          <Label>Senast svar från</Label>
          <Select
            value={senderFilter}
            onValueChange={(val: string) =>
              setSenderFilter(val as SenderFilter)
            }
          >
            <SelectTrigger className="w-full bg-background">
              <SelectValue placeholder="Filter" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Alla</SelectItem>
              <SelectItem value="ai">Julia AI</SelectItem>
              <SelectItem value="business">Företag</SelectItem>
              <SelectItem value="seller">Kandidat</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {isFeatureEnabled("SEND_FOR_REVIEW") && (
          <div className="w-1/2">
            <Label>Granskning</Label>
            <Select
              value={reviewFilter}
              onValueChange={(val: string) =>
                setReviewFilter(val as ReviewFilter)
              }
            >
              <SelectTrigger className="w-full bg-background">
                <SelectValue placeholder="Filter" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Alla</SelectItem>
                <SelectItem value="marked_for_review">
                  För granskning
                </SelectItem>
                <SelectItem value="not_for_review">
                  Inte för granskning
                </SelectItem>
                <SelectItem value="pending">Väntande</SelectItem>
              </SelectContent>
            </Select>
          </div>
        )}
      </div>
      <div>
        <Label>Sök kandidat</Label>
        <SidebarInput
          className="h-[36px] w-full"
          placeholder="T.ex. Erik Svensson..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
    </SidebarHeader>
  );
}
